export const LOADING = "LOADING";
export const FINISHED_LOADING = "FINISHED_LOADING";

export const FETCH_CARDS_SUCCESS = "FETCH_CARDS_SUCCESS";
export const FETCH_FILTER_SUCCESS = "FETCH_FILTER_SUCCESS";
export const LOGIN = "LOGIN";
export const RESET_STORE = "RESET_STORE";
export const RESET_MONITOREO_CREATE_NAME_ERROR = "RESET_MONITOREO_CREATE_NAME_ERROR";
export const FETCH_TOKEN = "FETCH_TOKEN";
export const URL = "URL";
export const FILTER_FLAG = "FILTER_FLAG";
export const FILTER_FLAG_SUCCESS = "FILTER_FLAG_SUCCESS";
export const FILTER_FLAG_ERROR = "FILTER_FLAG_ERROR";
export const FILTER_FLAG_MONITOREO = "FILTER_FLAG_MONITOREO";
export const FETCH_DESGRABADOR = "FETCH_DESGRABADOR";
export const SET_LABEL_DESGRABADOR = "SET_LABEL_DESGRABADOR";
export const SET_LABEL_TRELLO = "SET_LABEL_TRELLO";
export const FETCH_TRELLO = "FETCH_TRELLO";
export const CHANGE_VIEW = "CHANGE_VIEW";
export const FETCH_TRELLO_ERROR = "FETCH_TRELLO_ERROR";
export const FETCH_TEXTOS = "FETCH_TEXTOS";
export const FETCH_DAYS = "FETCH_DAYS";
export const FETCH_QUERY = "FETCH_QUERY";
export const FETCH_QUERY_NAME = "FETCH_QUERY_NAME";
export const FETCH_QUERY_TITLE = "FETCH_QUERY_TITLE";
export const FETCH_PAGE = "FETCH_PAGE";
export const FETCH_PAGE_CONVERSACION = "FETCH_PAGE_CONVERSACION";
export const FETCH_MEDIA = "FETCH_MEDIA";
export const FETCH_ORDER = "FETCH_ORDER";
export const FETCH_CATEGORY = "FETCH_CATEGORY";
export const FETCH_CARD_STATUS = "FETCH_CARD_STATUS";
export const FETCH_FAILURE = "FETCH_FAILURE";
export const FETCH_MESSAGES_APPMINISTRADOR_SUCCESS = "FETCH_MESSAGES_APPMINISTRADOR_SUCCESS";
export const FILTER_SIMILAR = "FILTER_SIMILAR";
export const FETCH_ITEMS_MENU = "FETCH_ITEMS_MENU";
export const FETCH_USER = "FETCH_USER";
export const FETCH_FILTER_APP_SUCCESS = "FETCH_FILTER_APP_SUCCESS";
export const FETCH_NEW_PASS = "FETCH_NEW_PASS";
export const FETCH_NEW_USER_DATA = "FETCH_NEW_USER_DATA";
export const FETCH_LIST = "FETCH_LIST";
export const FETCH_INVITATION = "FETCH_INVITATION";
export const FETCH_DELETE_INVITATION = "FETCH_DELETE_INVITATION";
export const FETCH_DELETE_PEDIDO = "FETCH_DELETE_PEDIDO";
export const FETCH_MEDIOS_USER_QSCH = "FETCH_MEDIOS_USER_QSCH";
export const FETCH_CODE_NEW_USER = "FETCH_CODE_NEW_USER";
export const FETCH_CODE_NEW_USER_FAIL = "FETCH_CODE_NEW_USER_FAIL";
export const FETCH_FIRST_PASS = "FETCH_FIRST_PASS";
export const FETCH_FIRST_PASS_FAILURE = "FETCH_FIRST_PASS_FAILURE";
export const ERROR_NEW_PASSWORD = "ERROR_NEW_PASSWORD";
export const ERROR_INVITATION = "ERROR_INVITATION";
export const ERROR_FILE = "ERROR_FILE";
export const ERROR_NEW_DATA = "ERROR_NEW_DATA";
export const RESET_PASSWORD_COMPLETE = "RESET_PASSWORD_COMPLETE";
export const RESET_PASSWORD_COMPLETE_FAILURE = "RESET_PASSWORD_COMPLETE_FAILURE";
export const FETCH_FILE_SUCCESS = "FETCH_FILE_SUCCESS";
export const FETCH_REDES_SUCCESS = "FETCH_REDES_SUCCESS";
export const FETCH_MONITOREO_USER_SUCCESS = "FETCH_MONITOREO_USER_SUCCESS";
export const FETCH_MONITOREO_USER_APP_ERROR = "FETCH_MONITOREO_USER_APP_ERROR";
export const FETCH_MENU_USUARIOS_SUCCESS = "FETCH_MENU_USUARIOS_SUCCESS";
export const FETCH_TRELLO_MONITOREO_REQUEST = "FETCH_TRELLO_MONITOREO_REQUEST";
export const FETCH_TRELLO_MONITOREO_SUCCESS = "FETCH_TRELLO_MONITOREO_SUCCESS";
export const FETCH_PEDIDOS_REQUEST = "FETCH_PEDIDOS_REQUEST";
export const FETCH_PEDIDOS_SUCCESS = "FETCH_PEDIDOS_SUCCESS";
export const FETCH_MESSAGES_APPMINISTRADOR_PEDIDOS_SUCCESS = "FETCH_MESSAGES_APPMINISTRADOR_PEDIDOS_SUCCESS";
export const POST_RESPONSE_SUCCESS = "POST_RESPONSE_SUCCESS";
export const POST_RESPONSE_FAILURE = "POST_RESPONSE_FAILURE";
export const FETCH_SIMILARES_SUCCESS = "FETCH_SIMILARES_SUCCESS";
export const FETCH_VEREDICTOS_SUCCESS = "FETCH_VEREDICTOS_SUCCESS";
export const FETCH_MENU_APP_SUCCESS = "FETCH_MENU_APP_SUCCESS";
export const FETCH_GRAFICO_SUCCESS = "FETCH_GRAFICO_SUCCESS";
export const FETCH_FILTER_APPMINISTRADOR = "FETCH_FILTER_APPMINISTRADOR";
export const POST_MESSAGES_APPMINISTRADOR_REQUEST_VALIDATION = "POST_MESSAGES_APPMINISTRADOR_REQUEST_VALIDATION";
export const RESET_REGISTRO_STATUS_MANUAL_SUCCESS = "RESET_REGISTRO_STATUS_MANUAL_SUCCESS";



/* NUEVO MONITOREO actions*/
export const FETCH_MONITOREO_SUCCESS = "FETCH_MONITOREO_SUCCESS";
export const FETCH_MONITOREO_SUCCESS_TRENDINGS = "FETCH_MONITOREO_SUCCESS_TRENDINGS";
export const FETCH_CATEGORIAS_DETALLE_SUCCESS = "FETCH_CATEGORIAS_DETALLE_SUCCESS";
export const FETCH_MONITOREO_SUCCESS_ID = "FETCH_MONITOREO_SUCCESS_ID";
export const FETCH_MONITOREO_SUCCESS_CATEGORIAS_FORM = "FETCH_MONITOREO_SUCCESS_CATEGORIAS_FORM";
export const FETCH_MONITOREO_SUCCESS_CARDS = "FETCH_MONITOREO_SUCCESS_CARDS";
export const FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_DETALLE = "FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_DETALLE";
export const POST_MONITOREO_ASOCIADO_SUCCESS = "POST_MONITOREO_ASOCIADO_SUCCESS";
export const FETCH_MONITOREO_ASOCIADO_FAILURE = "FETCH_MONITOREO_ASOCIADO_FAILURE";
export const RESET_REGISTRO_STATUS = "RESET_REGISTRO_STATUS";
export const FETCH_NUEVA_DESINFORMACION_SUCCESS = "FETCH_NUEVA_DESINFORMACION_SUCCESS";
export const RESET_REGISTRO_STATUS_MANUAL_ERROR = "RESET_REGISTRO_STATUS_MANUAL_ERROR";
export const FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_ID = "FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_ID";
export const RESET_REGISTRO_STATUS_MANUAL = "RESET_REGISTRO_STATUS_MANUAL";
export const UPDATE_MONITOREO_CARDS = "UPDATE_MONITOREO_CARDS";
export const FETCH_REGISTRADOS_PAGE_SUCCESS = "FETCH_REGISTRADOS_PAGE_SUCCESS";
export const FETCH_MONITOREO_SUCCESS_NUEVO_ID = "FETCH_MONITOREO_SUCCESS_NUEVO_ID";
export const FETCH_REGISTRO_ID_SUCCESS = "FETCH_REGISTRO_ID_SUCCESS";
export const FETCH_REGISTRO_ID_DATA_SUCCESS = "FETCH_REGISTRO_ID_DATA_SUCCESS";
export const FETCH_TRELLO_SUCCESS = "FETCH_TRELLO_SUCCESS";
export const RESET_DESGRABADOR = "RESET_DESGRABADOR";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_CAMPANAS_SUCCESS = "FETCH_DATA_CAMPANAS_SUCCESS";
export const MONITOREO__TOGGLE_FORM = "MONITOREO__TOGGLE_FORM";
export const CHEQUEADOR__TOGGLE_FORM = "CHEQUEADOR__TOGGLE_FORM";
export const MONITOREO__SET_LOAD_PUBLICATION_CARD_SELECTED_ID = "MONITOREO__SET_LOAD_PUBLICATION_CARD_SELECTED_ID";
export const MONITOREO__NEW_CARD_CREATED = "MONITOREO__NEW_CARD_CREATED";
export const MONITOREO__FETCH_CARD_SELECTED = "MONITOREO__FETCH_CARD_SELECTED";
export const MONITOREO__FETCH_ALL_EVENTS = "MONITOREO__FETCH_ALL_EVENTS";
export const MONITOREO__FETCH_ALL_TOPICS = "MONITOREO__FETCH_ALL_TOPICS";
export const MONITOREO__NEW_EVENT = "MONITOREO__NEW_EVENT";
export const FETCH_HITORIAL_DESGRABADOR = "FETCH_HITORIAL_DESGRABADOR";
export const FETCH_HITORIAL_DESGRABADOR_ID = "FETCH_HITORIAL_DESGRABADOR_ID";
export const SET_LABEL_DESGRABADOR_HISTORIAL = "SET_LABEL_DESGRABADOR_HISTORIAL";
export const FETCH_HITORIAL_DESGRABADOR_FICHERO = "FETCH_HITORIAL_DESGRABADOR_FICHERO";
export const FETCH_HITORIAL_DESGRABADOR_FICHERO_ID = "FETCH_HITORIAL_DESGRABADOR_FICHERO_ID";
export const FETCH_DESGRABADOR_ERROR = "FETCH_DESGRABADOR_ERROR";
export const FETCH_DESGRABADOR_FICHERO_ERROR = "FETCH_DESGRABADOR_FICHERO_ERROR";
export const FETCH_DESGRABADOR_ERROR_CLEAN = "FETCH_DESGRABADOR_ERROR_CLEAN";
export const CLEAR_LABEL_DESGRABADOR = "CLEAR_LABEL_DESGRABADOR";


/* CHEQUEADOR */

export const FETCH_VERIFICACIONES = "FETCH_VERIFICACIONES";
export const FETCH_VERIFICACIONES_DELETE = "FETCH_VERIFICACIONES_DELETE";
export const FETCH_VERIFICACIONES_ID = "FETCH_VERIFICACIONES_ID";
export const FETCH_VERIFICACIONES_NEW = "FETCH_VERIFICACIONES_NEW";
export const RESET_CHEQUEADOR_VERIFICACIONES_NEW = "RESET_CHEQUEADOR_VERIFICACIONES_NEW";
export const FETCH_VERIFICACIONES_RATING = "FETCH_VERIFICACIONES_RATING";
export const UPDATE_VERIFICACION = "UPDATE_VERIFICACION";
export const UPDATE_VERIFICACION_IN_STORE = "UPDATE_VERIFICACION_IN_STORE";
export const VERIFICACIONES__IS__EDIT = "VERIFICACIONES__IS__EDIT";
export const VERIFICACIONES__BORRADOR = "VERIFICACIONES__BORRADOR";
export const VERIFICACIONES__BORRADOR__DATA__EDITAR = "VERIFICACIONES__BORRADOR__DATA__EDITAR";
export const VERIFICACIONES__BORRADOR__DATA__NUEVO = "VERIFICACIONES__BORRADOR__DATA__NUEVO";
export const SET_UPLOADING_FILE = "SET_UPLOADING_FILE";
export const FETCH_MONITOREO_REQUEST = "FETCH_MONITOREO_REQUEST";
export const FETCH_MONITOREO_REQUEST_SEARCH = "FETCH_MONITOREO_REQUEST_SEARCH";
export const SHOW_ERROR_MODAL = "SHOW_ERROR_MODAL";
export const SHOW_ERROR_MODAL_CLOSE = "SHOW_ERROR_MODAL_CLOSE";






